"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CalendarTimeSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M25.89,24.45A1,1,0,0,1,25,25a.93.93,0,0,1-.45-.11L22,23.62V21a1,1,0,0,1,2,0v1.38l1.45.73A1,1,0,0,1,25.89,24.45Z"/><path d="M26,11V7a3,3,0,0,0-3-3H5A3,3,0,0,0,2,7v4Z"/><path d="M26,16.67h0V13L2,13V23a3,3,0,0,0,3,3H16.69A7,7,0,1,0,26,16.67ZM23,28a5,5,0,1,1,5-5A5,5,0,0,1,23,28Z"/><path d="M21,2a1,1,0,0,0-1,1V4h2V3A1,1,0,0,0,21,2Z"/><path d="M8,3A1,1,0,0,0,6,3V4H8Z"/>';
var CalendarTimeSVG = function CalendarTimeSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.CalendarTimeSVG = CalendarTimeSVG;
CalendarTimeSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(CalendarTimeSVG);
exports.default = _default;